import $ from 'jquery';

$('#menu').on('show.bs.collapse', function () {
  $('.toggler-icon').addClass('toggler-icon-opened');
  $('body').css('overflow-y', 'hidden');
});

$('#menu').on('hide.bs.collapse', function () {
  $('.toggler-icon').removeClass('toggler-icon-opened');
  $('body').css('overflow-y', 'auto');
});
